<div class="btn-group advanced-report-menu" ngbDropdown role="group" aria-label="report dropdown menu">
  <button class="btn btn-settings" id="reportMenuBtn" [stPermissionToEnable]="permissionToEnableReportsMenu" qaa="advancedReportMenuBtn" ngbDropdownToggle>
    <i class="fas fa-chart-line me-3"></i>Advanced Reports
  </button>
  <div class="dropdown-menu st-fs-14" ngbDropdownMenu>
    <button id="dayCostReportBtn" qaa="dayCostReportBtn" class="dropdown-item" (click)="onDayCostReportBtnClicked()">Day Cost Report</button>
  </div>
</div>
